import { router } from './router';
import { twitchService } from './lib/twitch';
import { initAnalytics } from './utils/analytics';
import { initSentry } from './utils/sentry';
import './style.css';

// Initialize app
async function initApp() {
  initSentry();
  initAnalytics();

  // Check environment variables and initialize twitch service
  if (!import.meta.env.VITE_TWITCH_CLIENT_ID || !twitchService) {
    throw new Error('Missing required environment variables. Please check your .env file.');
  }

  // Ensure app container exists
  const app = document.querySelector<HTMLDivElement>('#app');
  if (!app) {
    const newApp = document.createElement('div');
    newApp.id = 'app';
    document.body.appendChild(newApp);
  }

  // Start the router
  await router();
}

// Handle any initialization errors
initApp().catch(error => {
  console.error('Failed to initialize app:', error);
  const app = document.querySelector<HTMLDivElement>('#app');
  if (app) {
    app.innerHTML = '<div style="color: red; padding: 2rem;">Failed to initialize application. Please check console for details.</div>';
  }
});
